
import { WOW } from "wowjs";

(function ($) {



	$(document).ready(function () {

		const wow = new WOW();
		let body 	= $( 'body' );

		wow.init();

		$(".google-translator").on( "click", function(e) {
			e.preventDefault();
			console.log($(document).height());
			console.log($('body').height()+100);
			// $("html, body").animate({ scrollTop: $(document).height()+100 });

			$('.navbar-toggler').click();

			$('html, body').animate({scrollTop: $("#translation").offset().top}, 1000);
			$('html, body').delay(100);
			$('html, body').animate({scrollTop: $("#translation").offset().top}, 500);

			$('html, body').delay(1000);
			$('html, body').delay(1000);

			$('#google_translate_element').css('border','solid 1px #CD4823');
				
		});

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		/**
		 * Carousel - Add negative margin to next block to accommodate extra spacing for shadow on mobile
		 */
		if ( window.innerWidth < 992 ) {
			$('.carousel-block + .orange-block').css('margin-top', '-20px');
		}

		/**
		 * Page Header - Add space below header on mobile for text overlap effect
		 */
		if ( window.innerWidth < 992 ) {
			let pageHeaderBlockHeight 	= $('.page-header-container').height() - 50;
			let pageHeaderImage 		= $('.page-header.has-image');

			pageHeaderImage.css('margin-bottom', pageHeaderBlockHeight);
		}

		/**
		 * Header - Add space below header
		 */
		let headerHeight 	= $('header').height() + 50 + 90; // Header height + top gap + gap between header and page header content block
		let pageHeader		= $('.page-header');
		pageHeader.css('padding-top', headerHeight);

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear()
		$( '#copyright-year' ).text( copyrightYear );

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() >= 100){
			body.addClass('sticky-header');
		} else {
			body.removeClass('sticky-header');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() >= 100){
				body.addClass('sticky-header');
				$('header').addClass('sticky-header');
			} else {
				body.removeClass('sticky-header');
				$('header').removeClass('sticky-header');
			}
		});

		// Add a class to body to prevent overflow when the menu is open
		$( ".navbar-toggler" ).on( "click", function() {
			$('body').toggleClass('menu-enabled')
		});

		// Control sub-menus on mobile
		$( ".menu-item-has-children > a" ).on( "click", function(e) {
			e.preventDefault();
			console.log('prevent');
			$(this).parent().toggleClass('open');
		});		
		

		// Check if the alert system exist in the page to add a special class to the header
		if ( $('#alert-system').is(":visible") ) {
			$('header').addClass('alert-enabled');
		} else {
			$('body').addClass('alert-disabled');
		}

		// Remove alert-enabled when click to close the alert
		$( "#alert-system .close" ).on( "click", function() {
			$('header').removeClass('alert-enabled')
			$('body').addClass('alert-disabled');
		});

		// Check if the Project Logo is visible, if yes, hide the h1 title
		if ( $('.navbar-brand img').is(":visible") ) {
			$('.navbar-brand h1').addClass('logo-visible');
		}

		/**
		 * Header - Add top position on menu to accommodate alert bar
		 */
		if (window.innerWidth < 992) {
			let alertHeight 	= $('#alert-system').height();
			let header 			= $('nav.navbar');

			header.css('top', ( alertHeight - 10 ) + 'px');

			console.log(header);
			console.log(alertHeight);
		}

		/**
		 * Carousel - Set equal heights
		 */
		function carouselEqualHeights() {
			$('.carousel-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				// Desktop
				if(window.innerWidth >= 993) {
					$.each( items, function() {
						let caption 		= $('.carousel-caption', this);
						let captionHeight 	= caption.outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight + 400);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});

					// Mobile
				} else {
					$.each( items, function() {
						let caption 		= $(this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});
				}

				// Add the active class back to the first slide
				$('.carousel-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		carouselEqualHeights();

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialEqualHeights() {
			$('.testimonial-large-block, .testimonial-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each( items, function() {
					let caption 		= $('.card-body', this);
					let captionHeight 	= caption.outerHeight();

					if ( captionHeight > maxHeight ) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each( items, function() {
					let caption = $('.card-body', this);
					caption.css( 'height', maxHeight );

					// Remove .active from all slides
					$( this ).removeClass( 'active' );
				});

				// Add the active class back to the first slide
				$('.testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		testimonialEqualHeights();

	});
})(jQuery);